/* Copyright (c) 2023 Learning Curve Group */

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import GlobalStyle from './ui/global/GlobalStyle';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { StateProvider } from "./services/state";
import { reducer, initialState } from "./services/reducer";
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from 'styled-components';
import { theme } from './ui/global/theme';
import FeedbackModal from './screens/FeedbackModal/FeedbackModal';
import CookieBanner from './components/CookieBanner';

const SENTRY_DSN_CLIENT = process.env.NODE_ENV === "production" ? process.env.REACT_APP_SENTRY_DSN_CLIENT : "";

Sentry.init({
  dsn: SENTRY_DSN_CLIENT,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV
});

const routing = (
  <Sentry.ErrorBoundary fallback={"An error has occurred"}>
    <StateProvider initialState={initialState} reducer={reducer}>
      <ThemeProvider theme={theme}>
        <FeedbackModal />
        <GlobalStyle />
        <Router>
          <App />
        </Router>
        <CookieBanner />
      </ThemeProvider>
    </StateProvider>
  </Sentry.ErrorBoundary>
);

ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
